import React, { useContext, useEffect, useState } from 'react';
import { FormContext } from '../Form';
import Button from '../Button';
import Row from '../../layout/Row';
import Input from '../Input';
import WCImages from '../assetCollections/WCImages';
import styled from 'styled-components';
import { dec2Hex } from '../../utility/functions';

const Wrapper = styled.div`
    position: relative;
`

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 95%;
    background: ${({ color }) => color}cc;
`

const ImageIndex = ({ ...props }) => {
    const context = useContext(FormContext);
    const colorName = props.colorName || 'logoColor';
    const indexName = props.name || 'logoImageIndex';

    const [images] = useState(props.images || WCImages);
    // const [hasColor, setHasColour] = useState(context.values[colorName] ? true : false);

    const updateState = (num) => context.setValue(indexName, getImage(num))

    const getImage = (num) => (num + (context.values[indexName] || 0)) % images.length;

    // useEffect(() => {
    //     setHasColour(context.values[colorName] ? true : false);
    // }, [context.initial])

    // useEffect(() => {
    //     setHasColour(context.values[colorName] ? true : false);
    // }, [context.values[colorName]])

    return (
        <>
            <Row>
                <b>Image</b>
                <Input
                    name={props.name || 'logoImageIndex'}
                    type='hidden'
                    {...props}
                />
            </Row>
            <Row>
                <Button
                    onClick={() => updateState(-1)}
                    icon='arrowLeft'
                    disabled={context ? context.submitting || context.editing || props.disable : props.disable}
                />
                {
                    context.values[indexName] > 0 ?
                        <Wrapper>
                            {context.values[colorName] ? <Overlay color={dec2Hex(context.values[colorName])} /> : null}
                            <img src={images[context.values[indexName]]} alt='imageIndex' />
                        </Wrapper>
                        : <b>No Image</b>
                }
                <Button
                    onClick={() => updateState(1)}
                    icon='arrowRight'
                    disabled={context ? context.submitting || context.editing || props.disable : props.disable}
                />
            </Row>
        </>
    )
}

export default ImageIndex;
